export const productColors = {
  'Marketing Center': '#E87722',
  'Business Center': '#7B2D8B',
  'Workforce Center': '#0070C0',
  'Reporting Center': '#00A651',
  'My Account': '#E87722',
  'Keap Max': '#00A98F',
  'Add-ons': '#F59E0B',
}

export const getProductColor = productName => {
  const key = Object.keys(productColors).find(k =>
    productName?.toLowerCase().includes(k.toLowerCase()),
  )
  return productColors[key] ?? '#E87722' // fallback bg color
}
